import type { PercentileCurvePoint } from './types'

// Source: WHO Child Growth Standards (2006)
// https://www.who.int/tools/child-growth-standards/standards/

export const heightForAgeBoys: PercentileCurvePoint[] = [
  { month: 0, p3: 46.3, p15: 47.9, p50: 49.9, p85: 51.8, p97: 53.4 },
  { month: 1, p3: 51.1, p15: 52.7, p50: 54.7, p85: 56.7, p97: 58.4 },
  { month: 2, p3: 54.7, p15: 56.4, p50: 58.4, p85: 60.5, p97: 62.2 },
  { month: 3, p3: 57.6, p15: 59.3, p50: 61.4, p85: 63.5, p97: 65.3 },
  { month: 4, p3: 60, p15: 61.7, p50: 63.9, p85: 66, p97: 67.8 },
  { month: 5, p3: 61.9, p15: 63.7, p50: 65.9, p85: 68.1, p97: 69.9 },
  { month: 6, p3: 63.6, p15: 65.4, p50: 67.6, p85: 69.8, p97: 71.6 },
  { month: 7, p3: 65.1, p15: 66.9, p50: 69.2, p85: 71.4, p97: 73.2 },
  { month: 8, p3: 66.5, p15: 68.3, p50: 70.6, p85: 72.9, p97: 74.7 },
  { month: 9, p3: 67.7, p15: 69.6, p50: 72, p85: 74.3, p97: 76.2 },
  { month: 10, p3: 69, p15: 70.9, p50: 73.3, p85: 75.6, p97: 77.6 },
  { month: 11, p3: 70.2, p15: 72.1, p50: 74.5, p85: 77, p97: 78.9 },
  { month: 12, p3: 71.3, p15: 73.3, p50: 75.7, p85: 78.2, p97: 80.2 },
  { month: 13, p3: 72.4, p15: 74.4, p50: 76.9, p85: 79.4, p97: 81.5 },
  { month: 14, p3: 73.4, p15: 75.5, p50: 78, p85: 80.6, p97: 82.7 },
  { month: 15, p3: 74.4, p15: 76.5, p50: 79.1, p85: 81.8, p97: 83.9 },
  { month: 16, p3: 75.4, p15: 77.5, p50: 80.2, p85: 82.9, p97: 85.1 },
  { month: 17, p3: 76.3, p15: 78.5, p50: 81.2, p85: 84, p97: 86.2 },
  { month: 18, p3: 77.2, p15: 79.5, p50: 82.3, p85: 85.1, p97: 87.3 },
  { month: 19, p3: 78.1, p15: 80.4, p50: 83.2, p85: 86.1, p97: 88.4 },
  { month: 20, p3: 78.9, p15: 81.3, p50: 84.2, p85: 87.1, p97: 89.5 },
  { month: 21, p3: 79.7, p15: 82.2, p50: 85.1, p85: 88.1, p97: 90.5 },
  { month: 22, p3: 80.5, p15: 83, p50: 86, p85: 89.1, p97: 91.6 },
  { month: 23, p3: 81.3, p15: 83.8, p50: 86.9, p85: 90, p97: 92.6 },
  { month: 24, p3: 81.4, p15: 83.9, p50: 87.1, p85: 90.3, p97: 92.9 },
  { month: 25, p3: 82.1, p15: 84.7, p50: 88, p85: 91.2, p97: 93.8 },
  { month: 26, p3: 82.8, p15: 85.5, p50: 88.8, p85: 92.1, p97: 94.8 },
  { month: 27, p3: 83.5, p15: 86.3, p50: 89.6, p85: 93, p97: 95.7 },
  { month: 28, p3: 84.2, p15: 87, p50: 90.4, p85: 93.8, p97: 96.6 },
  { month: 29, p3: 84.9, p15: 87.7, p50: 91.2, p85: 94.7, p97: 97.5 },
  { month: 30, p3: 85.5, p15: 88.4, p50: 91.9, p85: 95.5, p97: 98.3 },
  { month: 31, p3: 86.2, p15: 89.1, p50: 92.7, p85: 96.2, p97: 99.2 },
  { month: 32, p3: 86.8, p15: 89.7, p50: 93.4, p85: 97, p97: 100 },
  { month: 33, p3: 87.4, p15: 90.4, p50: 94.1, p85: 97.8, p97: 100.8 },
  { month: 34, p3: 88, p15: 91, p50: 94.8, p85: 98.5, p97: 101.5 },
  { month: 35, p3: 88.5, p15: 91.6, p50: 95.4, p85: 99.2, p97: 102.3 },
  { month: 36, p3: 89.1, p15: 92.2, p50: 96.1, p85: 99.9, p97: 103.1 },
  { month: 37, p3: 89.7, p15: 92.8, p50: 96.7, p85: 100.6, p97: 103.8 },
  { month: 38, p3: 90.2, p15: 93.4, p50: 97.4, p85: 101.3, p97: 104.5 },
  { month: 39, p3: 90.8, p15: 94, p50: 98, p85: 102, p97: 105.2 },
  { month: 40, p3: 91.3, p15: 94.6, p50: 98.6, p85: 102.7, p97: 105.9 },
  { month: 41, p3: 91.9, p15: 95.2, p50: 99.2, p85: 103.3, p97: 106.6 },
  { month: 42, p3: 92.4, p15: 95.7, p50: 99.9, p85: 104, p97: 107.3 },
  { month: 43, p3: 92.9, p15: 96.3, p50: 100.4, p85: 104.6, p97: 108 },
  { month: 44, p3: 93.4, p15: 96.8, p50: 101, p85: 105.2, p97: 108.6 },
  { month: 45, p3: 93.9, p15: 97.4, p50: 101.6, p85: 105.8, p97: 109.3 },
  { month: 46, p3: 94.4, p15: 97.9, p50: 102.2, p85: 106.5, p97: 109.9 },
  { month: 47, p3: 94.9, p15: 98.5, p50: 102.8, p85: 107.1, p97: 110.6 },
  { month: 48, p3: 95.4, p15: 99, p50: 103.3, p85: 107.7, p97: 111.2 },
  { month: 49, p3: 95.9, p15: 99.5, p50: 103.9, p85: 108.3, p97: 111.8 },
  { month: 50, p3: 96.4, p15: 100, p50: 104.4, p85: 108.9, p97: 112.5 },
  { month: 51, p3: 96.9, p15: 100.5, p50: 105, p85: 109.5, p97: 113.1 },
  { month: 52, p3: 97.4, p15: 101.1, p50: 105.6, p85: 110.1, p97: 113.7 },
  { month: 53, p3: 97.9, p15: 101.6, p50: 106.1, p85: 110.7, p97: 114.3 },
  { month: 54, p3: 98.4, p15: 102.1, p50: 106.7, p85: 111.2, p97: 115 },
  { month: 55, p3: 98.8, p15: 102.6, p50: 107.2, p85: 111.8, p97: 115.6 },
  { month: 56, p3: 99.3, p15: 103.1, p50: 107.8, p85: 112.4, p97: 116.2 },
  { month: 57, p3: 99.8, p15: 103.6, p50: 108.3, p85: 113, p97: 116.8 },
  { month: 58, p3: 100.3, p15: 104.1, p50: 108.9, p85: 113.6, p97: 117.4 },
  { month: 59, p3: 100.8, p15: 104.7, p50: 109.4, p85: 114.2, p97: 118.1 },
  { month: 60, p3: 101.2, p15: 105.2, p50: 110, p85: 114.8, p97: 118.7 }
]

export const heightForAgeGirls: PercentileCurvePoint[] = [
  { month: 0, p3: 45.6, p15: 47.2, p50: 49.1, p85: 51.1, p97: 52.7 },
  { month: 1, p3: 50, p15: 51.7, p50: 53.7, p85: 55.7, p97: 57.4 },
  { month: 2, p3: 53.2, p15: 55, p50: 57.1, p85: 59.2, p97: 60.9 },
  { month: 3, p3: 55.8, p15: 57.6, p50: 59.8, p85: 62, p97: 63.8 },
  { month: 4, p3: 58, p15: 59.8, p50: 62.1, p85: 64.3, p97: 66.2 },
  { month: 5, p3: 59.9, p15: 61.7, p50: 64, p85: 66.3, p97: 68.2 },
  { month: 6, p3: 61.5, p15: 63.4, p50: 65.7, p85: 68.1, p97: 70 },
  { month: 7, p3: 62.9, p15: 64.9, p50: 67.3, p85: 69.7, p97: 71.6 },
  { month: 8, p3: 64.3, p15: 66.3, p50: 68.7, p85: 71.2, p97: 73.2 },
  { month: 9, p3: 65.6, p15: 67.6, p50: 70.1, p85: 72.6, p97: 74.7 },
  { month: 10, p3: 66.8, p15: 68.9, p50: 71.5, p85: 74, p97: 76.1 },
  { month: 11, p3: 68, p15: 70.2, p50: 72.8, p85: 75.4, p97: 77.5 },
  { month: 12, p3: 69.2, p15: 71.3, p50: 74, p85: 76.7, p97: 78.9 },
  { month: 13, p3: 70.3, p15: 72.5, p50: 75.2, p85: 77.9, p97: 80.2 },
  { month: 14, p3: 71.3, p15: 73.6, p50: 76.4, p85: 79.2, p97: 81.4 },
  { month: 15, p3: 72.4, p15: 74.7, p50: 77.5, p85: 80.3, p97: 82.7 },
  { month: 16, p3: 73.3, p15: 75.7, p50: 78.6, p85: 81.5, p97: 83.9 },
  { month: 17, p3: 74.3, p15: 76.7, p50: 79.7, p85: 82.6, p97: 85 },
  { month: 18, p3: 75.2, p15: 77.7, p50: 80.7, p85: 83.7, p97: 86.2 },
  { month: 19, p3: 76.2, p15: 78.7, p50: 81.7, p85: 84.8, p97: 87.3 },
  { month: 20, p3: 77, p15: 79.6, p50: 82.7, p85: 85.8, p97: 88.4 },
  { month: 21, p3: 77.9, p15: 80.5, p50: 83.7, p85: 86.8, p97: 89.4 },
  { month: 22, p3: 78.7, p15: 81.4, p50: 84.6, p85: 87.8, p97: 90.5 },
  { month: 23, p3: 79.6, p15: 82.2, p50: 85.5, p85: 88.8, p97: 91.5 },
  { month: 24, p3: 79.6, p15: 82.4, p50: 85.7, p85: 89.1, p97: 91.8 },
  { month: 25, p3: 80.4, p15: 83.2, p50: 86.6, p85: 90, p97: 92.8 },
  { month: 26, p3: 81.2, p15: 84, p50: 87.4, p85: 90.9, p97: 93.7 },
  { month: 27, p3: 81.9, p15: 84.8, p50: 88.3, p85: 91.8, p97: 94.6 },
  { month: 28, p3: 82.6, p15: 85.5, p50: 89.1, p85: 92.7, p97: 95.6 },
  { month: 29, p3: 83.4, p15: 86.3, p50: 89.9, p85: 93.5, p97: 96.4 },
  { month: 30, p3: 84, p15: 87, p50: 90.7, p85: 94.3, p97: 97.3 },
  { month: 31, p3: 84.7, p15: 87.7, p50: 91.4, p85: 95.2, p97: 98.2 },
  { month: 32, p3: 85.4, p15: 88.4, p50: 92.2, p85: 95.9, p97: 99 },
  { month: 33, p3: 86, p15: 89.1, p50: 92.9, p85: 96.7, p97: 99.8 },
  { month: 34, p3: 86.7, p15: 89.8, p50: 93.6, p85: 97.5, p97: 100.6 },
  { month: 35, p3: 87.3, p15: 90.5, p50: 94.4, p85: 98.3, p97: 101.4 },
  { month: 36, p3: 87.9, p15: 91.1, p50: 95.1, p85: 99, p97: 102.2 },
  { month: 37, p3: 88.5, p15: 91.7, p50: 95.7, p85: 99.7, p97: 103 },
  { month: 38, p3: 89.1, p15: 92.4, p50: 96.4, p85: 100.5, p97: 103.7 },
  { month: 39, p3: 89.7, p15: 93, p50: 97.1, p85: 101.2, p97: 104.5 },
  { month: 40, p3: 90.3, p15: 93.6, p50: 97.7, p85: 101.9, p97: 105.2 },
  { month: 41, p3: 90.8, p15: 94.2, p50: 98.4, p85: 102.6, p97: 106 },
  { month: 42, p3: 91.4, p15: 94.8, p50: 99, p85: 103.3, p97: 106.7 },
  { month: 43, p3: 92, p15: 95.4, p50: 99.7, p85: 103.9, p97: 107.4 },
  { month: 44, p3: 92.5, p15: 96, p50: 100.3, p85: 104.6, p97: 108.1 },
  { month: 45, p3: 93, p15: 96.6, p50: 100.9, p85: 105.3, p97: 108.8 },
  { month: 46, p3: 93.6, p15: 97.2, p50: 101.5, p85: 105.9, p97: 109.5 },
  { month: 47, p3: 94.1, p15: 97.7, p50: 102.1, p85: 106.6, p97: 110.2 },
  { month: 48, p3: 94.6, p15: 98.3, p50: 102.7, p85: 107.2, p97: 110.8 },
  { month: 49, p3: 95.1, p15: 98.8, p50: 103.3, p85: 107.8, p97: 111.5 },
  { month: 50, p3: 95.7, p15: 99.4, p50: 103.9, p85: 108.4, p97: 112.1 },
  { month: 51, p3: 96.2, p15: 99.9, p50: 104.5, p85: 109.1, p97: 112.8 },
  { month: 52, p3: 96.7, p15: 100.4, p50: 105, p85: 109.7, p97: 113.4 },
  { month: 53, p3: 97.2, p15: 101, p50: 105.6, p85: 110.3, p97: 114.1 },
  { month: 54, p3: 97.6, p15: 101.5, p50: 106.2, p85: 110.9, p97: 114.7 },
  { month: 55, p3: 98.1, p15: 102, p50: 106.7, p85: 111.5, p97: 115.3 },
  { month: 56, p3: 98.6, p15: 102.5, p50: 107.3, p85: 112.1, p97: 116 },
  { month: 57, p3: 99.1, p15: 103, p50: 107.8, p85: 112.6, p97: 116.6 },
  { month: 58, p3: 99.6, p15: 103.5, p50: 108.4, p85: 113.2, p97: 117.2 },
  { month: 59, p3: 100, p15: 104, p50: 108.9, p85: 113.8, p97: 117.8 },
  { month: 60, p3: 100.5, p15: 104.5, p50: 109.4, p85: 114.4, p97: 118.4 }
]
